import React, { Component } from 'react';
import './taskBoard.css';
import ScrollArea from 'react-scrollbar';
import UniqId from 'uniqid';
import { Fab, Action } from 'react-tiny-fab';
import {
  IoIosSettings,
  IoMdCreate,
  IoMdClose,
  IoMdAddCircleOutline,
  IoMdCheckmark
} from 'react-icons/io';
import { FiTrash, FiCopy } from 'react-icons/fi';
import './styles.min.css';
import { Form, TextField, SubmitField } from 'react-components-form';
import Chips from 'react-chips';
import Column from './column/column';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { ConfigProvider } from 'react-avatar';

export default class TaskBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemToRender: this.props.taskBoardToRender,
      isEditEnabled: false,
      newtags: this.props.taskBoardToRender.tags,
      error: '',
      isNewColumnEnabled: false,
      newColumnName: ''
    };
  }

  makeTaskEditable = () => {
    this.toggleEditableTask();
  };

  toggleNewColumnVisibility = () => {
    this.setState({
      isNewColumnEnabled: !this.state.isNewColumnEnabled
    });
    this.setState({
      error: '',
      newColumnName: ''
    });
  };

  addNewColumn = () => {
    this.toggleEditableTask();
    this.toggleNewColumnVisibility();
  };

  saveNewColumn = () => {
    if (this.state.newColumnName) {
      this.props.addNewColumn(
        this.state.itemToRender.id,
        this.state.newColumnName
      );

      this.setState({
        error: '',
        newColumnName: '',
        itemToRender: this.props.taskBoardToRender
      });
      this.toggleEditableTask();
      this.toggleNewColumnVisibility();
    } else {
      this.setState({
        error: "I think you didn't enter column name !"
      });
    }
  };

  handleNewColumnName = event => {
    this.setState({
      newColumnName: event.target.value
    });
  };

  updateItemToRender = () => {
    this.setState({
      itemToRender: this.props.taskBoardToRender
    })
  }

  renderEditColumnInput = () => {
    return (
      <div className="add-new-column">
        <input
          value={this.state.newColumnName}
          onChange={e => {
            this.handleNewColumnName(e);
          }}
          placeholder="Column name.."
        />
        <IoMdCheckmark
          onClick={() => {
            this.saveNewColumn();
          }}
        />
        <IoMdClose
          onClick={() => {
            this.addNewColumn();
          }}
        />
        <div className="column-name-error">{this.state.error}</div>
      </div>
    );
  };

  saveEditedTask = model => {
    console.log(model);
    if (model.name && this.state.newtags.length !== 0) {
      this.setState({
        error: ''
      });
      const editedTask = {
        name: model.name,
        id: this.state.itemToRender.id,
        themeColor: this.state.itemToRender.themeColor,
        tags: this.state.newtags,
        creationDate: this.state.itemToRender.creationDate,
        content: this.state.itemToRender.content
      };
      this.props.modifyExistingTask(editedTask);
      this.renderEditedTask(editedTask);
      this.toggleEditableTask();
    } else {
      this.setState({
        error: "It seems you didn't fill all the fields !"
      });
    }
  };

  toggleEditableTask = () => {
    this.setState({
      isNewColumnEnabled: false,
      isEditEnabled: !this.state.isEditEnabled
    });
  };

  onTagsChange = chips => {
    this.setState({
      newtags: chips
    });
  };

  renderEditedTask = editedTask => {
    this.setState({
      itemToRender: editedTask,
      newtags: editedTask.tags
    });
  };

  renderEditTaskForm = () => {
    return (
      <Form onSubmit={this.saveEditedTask} className="new-item-form">
        <TextField
          name="name"
          type="text"
          value={this.state.itemToRender.name}
          className="item-textfield"
        />
        <Chips
          className="chips-container"
          value={this.state.newtags}
          onChange={this.onTagsChange}
          suggestions={['TODO', 'Shopping List', 'Task List']}
        />
        <SubmitField value="Save" />
        <div className="form-error">{this.state.error}</div>
      </Form>
    );
  };

  renderFAB = () => {
    const actionButtonStyles = {
      backgroundColor: this.state.itemToRender.themeColor || '#16a085'
    };
    return (
      <Fab
        mainButtonStyles={{
          backgroundColor: '#3498db'
        }}
        position={{
          bottom: 0,
          right: 0
        }}
        icon={<IoIosSettings />}
        event={'hover'}>
        <Action
          key="deleteaction"
          text="Delete"
          style={actionButtonStyles}
          onClick={() => {
            this.props.removeCurrentItem(this.state.itemToRender);
          }}
          children={<FiTrash />}
        />
        <Action
          key="copyaction"
          text="Copy"
          style={actionButtonStyles}
          onClick={() => {
            this.props.makeDashboardCopy(this.state.itemToRender.id);
          }}
          children={<FiCopy />}
        />
        {this.state.isEditEnabled ? (
          <Action
            key="cancelaction"
            text="Cancel"
            style={actionButtonStyles}
            onClick={() => {
              this.toggleEditableTask();
            }}
            children={<IoMdClose />}
          />
        ) : (
          [
            <Action
              key="editdashboard"
              text="Edit dashboard"
              style={actionButtonStyles}
              onClick={() => {
                this.makeTaskEditable();
              }}
              children={<IoMdCreate />}
            />,

            <Action
              key="addcolumn"
              text="Add Column"
              style={actionButtonStyles}
              onClick={() => {
                this.addNewColumn();
              }}
              children={<IoMdAddCircleOutline />}
            />
          ]
        )}
      </Fab>
    );
  };

  onDragEnd = result => {
    const { destination, source, draggableId, type } = result;

    if (!destination) {
      return;
    }
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    if (type === 'column') {
      const newColumnOrder = Array.from(
        this.state.itemToRender.content.columnOrder
      );
      newColumnOrder.splice(source.index, 1);
      newColumnOrder.splice(destination.index, 0, draggableId);

      const newState = {
        ...this.state.itemToRender.content,
        columnOrder: newColumnOrder
      };

      const newItemToRender = this.state.itemToRender;
      newItemToRender.content = newState;

      this.setState({
        itemToRender: newItemToRender
      });
      return;
    }

    const startColumn = this.state.itemToRender.content.columns[
      source.droppableId
    ];
    const finishColumn = this.state.itemToRender.content.columns[
      destination.droppableId
    ];

    //handling same column drop
    if (startColumn === finishColumn) {
      const newTaskIds = Array.from(startColumn.taskIds);
      newTaskIds.splice(source.index, 1);
      newTaskIds.splice(destination.index, 0, draggableId);

      const newColumn = {
        ...startColumn,
        taskIds: newTaskIds
      };

      const newState = {
        ...this.state.itemToRender.content,
        columns: {
          ...this.state.itemToRender.content.columns,
          [newColumn.id]: newColumn
        }
      };

      const newItemToRender = this.state.itemToRender;
      newItemToRender.content = newState;

      this.setState({
        itemToRender: newItemToRender
      });
      return;
    }

    const startTaskIds = Array.from(startColumn.taskIds);
    startTaskIds.splice(source.index, 1);
    const newStartColumn = {
      ...startColumn,
      taskIds: startTaskIds
    };

    const finishcolumnIds = Array.from(finishColumn.taskIds);
    finishcolumnIds.splice(destination.index, 0, draggableId);
    const newFinishColumn = {
      ...finishColumn,
      taskIds: finishcolumnIds
    };

    const newState = {
      ...this.state.itemToRender.content,
      columns: {
        ...this.state.itemToRender.content.columns,
        [newStartColumn.id]: newStartColumn,
        [newFinishColumn.id]: newFinishColumn
      }
    };

    const newItemToRender = this.state.itemToRender;
    newItemToRender.content = newState;

    this.setState({
      itemToRender: newItemToRender
    });
  };

  renderTaskBoardBody = () => {
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable
          droppableId="all-columns"
          direction="horizontal"
          type="column">
          {provided => (
            <ConfigProvider
              colors={[
                '#ef5350',
                '#42A5F5',
                '#66BB6A',
                '#FF7043',
                '#7E57C2',
                '#26C6DA',
                '#26A69A',
                '#AB47BC'
              ]}>
              <div
                style={{ height: '70vh', width: '100%' }}
                {...provided.droppableProps}
                ref={provided.innerRef}>
                {this.state.itemToRender.content.columnOrder.map(
                  (columnId, index) => {
                    const column = this.state.itemToRender.content.columns[
                      columnId
                    ];
                    const tasks = column.taskIds.map(
                      taskId => this.state.itemToRender.content.tasks[taskId]
                    );
                    return (
                      <Column
                        updateItemToRender={this.updateItemToRender}
                        taskBoardId={this.state.itemToRender.id}
                        key={column.id}
                        column={column}
                        tasks={tasks}
                        index={index}
                        themeColor={this.state.itemToRender.themeColor}
                        deleteExistingColumn={this.props.deleteExistingColumn}
                        addTaskToColumn={this.props.addTaskToColumn}
                        deleteExistingTask={this.props.deleteExistingTask}
                      />
                    );
                  }
                )}
                {provided.placeholder}
              </div>
            </ConfigProvider>
          )}
        </Droppable>
      </DragDropContext>
    );
  };

  render() {
    const backgroundStyle = {
      background: this.state.itemToRender.themeColor
    };

    return (
      <ScrollArea className="task-board" smoothScrolling={true}>
        {this.state.isEditEnabled ? (
          this.state.isNewColumnEnabled ? (
            this.renderEditColumnInput()
          ) : (
            this.renderEditTaskForm()
          )
        ) : (
          <div className="task-board-header">
            <h2 className="page-title">{this.state.itemToRender.name}</h2>
            <span className="task-board-tags-container">
              {this.state.itemToRender.tags.map(item => {
                return (
                  <span
                    className="tags-chips"
                    style={backgroundStyle}
                    key={UniqId()}>
                    {item}
                  </span>
                );
              })}
            </span>
          </div>
        )}

        <div className="task-board-body">{this.renderTaskBoardBody()}</div>
        {this.renderFAB()}
      </ScrollArea>
    );
  }
}
